export const messages = {
  en: {
    addScheduleClasses: {
      title: 'Add Schedule',
      name: 'Schedule Name',
      namePlaceholder: 'Required, please enter schedule name',
      scheduleType: 'Schedule Type',
      scheduleTypePlaceholder: 'Required, please select schedule type',
      daily: 'Daily Schedule',
      weekly: 'Weekly Schedule',
      monthly: 'Monthly Schedule'
    },
    scheduleClassesDay: {
      scheduleCycle: 'Schedule Cycle',
      scheduleCyclePlaceholder: 'Required, please select schedule cycle',
      day: 'Day',
      scheduleInfo: 'Schedule Information',
      rest: 'Rest'
    },
    scheduleClassesWeek: {
      scheduleCycle: 'Schedule Cycle',
      scheduleCyclePlaceholder: 'Required, please select schedule cycle',
      week: 'Week',
      scheduleInfo: 'Schedule Information',
      rest: 'Rest'
    },
    scheduleClassesMonth: {
      scheduleCycle: 'Schedule Cycle',
      scheduleCyclePlaceholder: 'Required, please select schedule cycle',
      month: 'Month',
      scheduleInfo: 'Schedule Information',
      rest: 'Rest'
    },
    editScheduleClassesDay: {
      title: 'Edit Schedule',
      status: 'Status',
      rest: 'Rest',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please enter start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please enter end time'
    }
  },
  zh: {
    addScheduleClasses: {
      title: '添加排班',
      name: '排班名称',
      namePlaceholder: '必填，请填写计划名称',
      scheduleType: '排班类型',
      scheduleTypePlaceholder: '必填，请选择排班类型',
      daily: '按日排班',
      weekly: '按周排班',
      monthly: '按月排班'
    },
    scheduleClassesDay: {
      scheduleCycle: '排班周期',
      scheduleCyclePlaceholder: '必填，请选择排班周期',
      day: '日',
      scheduleInfo: '排班信息',
      rest: '休息'
    },
    scheduleClassesWeek: {
      scheduleCycle: '排班周期',
      scheduleCyclePlaceholder: '必填，请选择排班周期',
      week: '周',
      scheduleInfo: '排班信息',
      rest: '休息'
    },
    scheduleClassesMonth: {
      scheduleCycle: '排班周期',
      scheduleCyclePlaceholder: '必填，请选择排班周期',
      month: '月',
      scheduleInfo: '排班信息',
      rest: '休息'
    },
    editScheduleClassesDay: {
      title: '修改',
      status: '状态',
      rest: '休息',
      startTime: '上班时间',
      startTimePlaceholder: '必填，请填写上班时间',
      endTime: '下班时间',
endTimePlaceholder: '必填，请填写下班时间'
    }
  },
  'zh-TW': {
    addScheduleClasses: {
      title: '添加排班',
      name: '排班名稱',
      namePlaceholder: '必填，請填寫計劃名稱',
      scheduleType: '排班類型',
      scheduleTypePlaceholder: '必填，請選擇排班類型',
      daily: '按日排班',
      weekly: '按週排班',
      monthly: '按月排班'
    },
    scheduleClassesDay: {
      scheduleCycle: '排班週期',
      scheduleCyclePlaceholder: '必填，請選擇排班週期',
      day: '日',
      scheduleInfo: '排班信息',
      rest: '休息'
    },
    scheduleClassesWeek: {
      scheduleCycle: '排班週期',
      scheduleCyclePlaceholder: '必填，請選擇排班週期',
      week: '週',
      scheduleInfo: '排班信息',
      rest: '休息'
    },
    scheduleClassesMonth: {
      scheduleCycle: '排班週期',
      scheduleCyclePlaceholder: '必填，請選擇排班週期',
      month: '月',
      scheduleInfo: '排班信息',
      rest: '休息'
    },
    editScheduleClassesDay: {
      title: '修改',
      status: '狀態',
      rest: '休息',
      startTime: '上班時間',
      startTimePlaceholder: '必填，請填寫上班時間',
      endTime: '下班時間',
      endTimePlaceholder: '必填，請填寫下班時間'
    }
  }
}